import { Injectable } from '@angular/core'
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  Resolve,
} from '@angular/router'
import { Observable } from 'rxjs'
import { Room } from '../../models/room.model'
import { RoomService } from '../../services'
import { Logger } from '../../logger.service'
import { map, catchError } from 'rxjs/operators'

const log = new Logger('RoomResolver')
@Injectable({ providedIn: 'root' })
export class RoomDetailResolver implements Resolve<Observable<Room>> {
  constructor(private roomService: RoomService, private router: Router) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> {
    let mode = route.params['mode']
    let rid = route.params['rid']
    
    return this.roomService.getRoomDetail(rid).pipe(
      map(data => {
        log.debug('Data: ', data)
        return data
      }),
      catchError(err => this.router.navigate(['/rooms']))
    )
  }
}
